import React from 'react';
import { get, head, map } from 'lodash';
import { withNetworkState } from 'ui/hoc/withNetworkState';

// local dependencies
import { insuranceBasicInformationForm as InsuranceBasicInformationForm, insuranceBasicInformationFormPreloader as InsuranceBasicInformationFormPreloaderPreloader } from 'ui/views/widgets/insuranceBasicInformationForm';
import { MemberCommunicationSettings } from 'ui/containers/MemberCommunicationSettings';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { radioBox as RadioBox } from 'ui/views/generic/radioBox';
import { entityInfoCells as EntityInfoCells } from 'ui/views/widgets/entityInfoCells';
import { MemberAddEditAddress } from 'ui/containers/MemberAddEditAddress';
import { memberInfoCommunicationSettingsPreloader as MemberInfoCommunicationSettingsPreloader } from 'ui/views/widgets/memberInfoCommunicationSettings';
import { button as Button } from 'modules/button';
import { MemberAddEditBillingAddress } from 'ui/containers/MemberAddEditBillingAddress';

/******************************************************* */

export const InsuranceDrugPreferenceForm = ( props ) => {

    const fieldData = head( props.fields );
    const optionList = get( props, `options.${fieldData.options}`, [] );
    const selectedVal = props.useGeneric;

    return (
        <div className='ui-insurance-drug-preference'>

            {/* title */ }
            <div className='ui-insurance-drug-preference__title'>
                <Icon id={ 'pill' } fill={ '#2d2d2d' } height={ 24 } width={ 24 } />
                { getLabel( props.title ) }
            </div>

            {/* label */}
            <div className='ui-insurance-drug-preference__section'>

                <div className='ui-insurance-drug-preference__section__label'>
                    <div className='ui-insurance-drug-preference__section__label__text'>
                        { getLabel( fieldData.title ) }
                    </div>

                    {/* required asterisk */}
                    {
                        props.required ? (
                            <div className='ui-insurance-drug-preference__section__label__asterisk'>*</div>
                        ) : null
                    }
                </div>
               
                {/* options */}
                <div className='ui-insurance-drug-preference__section__options'>

                    { map( optionList, option => {

                        return (
                            <div key={ option.name } className='ui-insurance-drug-preference__section__options__option' onClick={ () => props.onSwitchDrugPrefernce( { value: option.value } ) }>
                                <RadioBox
                                    id={ option.name }
                                    name={ option.name }
                                    value={ option.value }
                                    selected={ option.value === selectedVal }
                                />
                                { getLabel( option.title ) }
                            </div>
                        );
                    } ) }
                </div>
            </div>
        </div>
    );
};

/******************************************************* */

export const InsuranceInformation = ( props ) => {
    
    return (
        <div className='ui-insurance-inmformation'>

            {/* title */ }
            <div className='ui-insurance-inmformation__title'>
                <Icon id={ 'document' } />
                { getLabel( props.title ) }
            </div>

            {/* label */}
            <div className='ui-insurance-inmformation__section'>

                <EntityInfoCells
                    items={ props.fields }
                    values={ props.currentInsurance }
                    className={ 'ui-insurance-inmformation__section__cell' }
                    options= { props.options }
                />
               
            </div>
        </div>
    );
};

/***************************************************** */
export const _epostInsuranceInformation = ( props ) => {
    const isDrug = props.visibility.drugPreferenceAction
    const isBilling = props.visibility.addBillingAddressAction
    return (
        <div className='ui-epost-insurance-information'>

            <div className='ui-epost-insurance-information__basic'>
                
                {/* basic information view */}
                <InsuranceBasicInformationForm
                    values={ get( props, 'basicInformation', {} ) }
                    sectionData={ get( props, 'sections.basicInformation', {} ) }
                    className={ 'ui-epost-insurance-information__basic__form' }
                    onFormSubmit={ props.onBasicInfoUpdate }
                />

                <div className='ui-epost-insurance-information__basic__contact'>

                    <div className='ui-epost-insurance-information__basic__contact__title'>
                        <Icon id={ 'phone' } fill={ '#000' } />

                        <div className='ui-epost-insurance-information__basic__contact__title__value'>
                            { getLabel( get( props, 'sections.contactInformation.title', {} ) ) }
                        </div>
                        <div className="ui-input-field__editable__label__asterisk">* </div>
                    </div>

                    {/* contact information */}
                    <MemberCommunicationSettings
                        { ...get( props, 'sections.contactInformation', {} ) }
                        { ...get( props, 'contactInformation', {} ) }
                        options={ get( props, 'options' ) }
                        actionClassName={ 'ui-epost-insurance-information__basic__action'}
                        onAddEditClick={ props.onAddEditCommunicationDetail }
                        onDefaultClick= { props.onCommunicationDefaultSelection }
                        onDeleteClick={ props.onCommunicationDelete }
                    />
                </div>
            </div>
     
            {/* drug preference */}
           {isDrug && <InsuranceDrugPreferenceForm
                { ...get( props, 'sections.drugPreference', {} ) }
                { ...get( props, 'drugPreference', {} ) }
                options={ get( props, 'options' ) }
                onSwitchDrugPrefernce={ props.onSwitchDrugPrefernce }
            />}

            {/* InsuranceInformation */}
            <InsuranceInformation
                { ...get( props, 'sections.insurance', {} ) }
                { ...get( props, 'insurance', {} ) }
                { ...get( props, 'sections.insurance' ) }
                options={ get( props, 'options' ) }
            />

            {/* address info shipping */}
            <MemberAddEditAddress
                { ...get( props, 'shippingAddress' ) }
                { ...get( props, 'sections.shippingAddress', {} ) }
                options={ get( props, 'options' ) }
                className={ 'ui-epost-insurance-information__basic__shipping' }
                onAddEditAddressClick={ props.onAddEditAddressClick }
                onAddressDelete={ props.onAddressDelete }
                onDefaultSelection= { props.onAddressDefaultSelection }
                defaultDescription= { get( props, 'defaultDescription', {} ) }
                changeConfirmation= { get( props, 'changeConfirmation', {} ) }
                enrollToEpostJourney={ true }
            />

            {/* address info billing */}
       {isBilling && <MemberAddEditBillingAddress
                { ...get( props, 'billingAddress' ) }
                { ...get( props, 'sections.billingAddress', {} ) }
                shippingAddress= { get( props, 'shippingAddress' ) }
                options={ get( props, 'options' ) }
                className={ 'ui-epost-insurance-information__basic__billing' }
                onAddEditAddressClick={ props.onAddEditAddressClickBasedOnSection }
                onAddressDelete={ props.onAddressDeleteBasedOnSection }
                onDefaultSelection= { props.onAddressDefaultSelectionBasedOnSection }
                onSwitchSameAsShipping= { props.onSwitchBillingAddressSameAsShipping }
                defaultDescription= { get( props, 'defaultDescription', {} ) }
                changeConfirmation= { get( props, 'changeConfirmation', {} ) }
                enrollToEpostJourney={ true }
                sectionName = { 'billingAddress' }
            />}

            <div className='ui-epost-insurance-information__actions'>
                { map( props.navActions, action => {
                    return(
                        <Button
                            className={  'ui-epost-insurance-information__actions__action' }
                            { ...action }
                            outline = { 'cancel' === action.name ? true: false }
                            size='large'
                            key={ action.name }
                            onClick={ () => props.onNavActionClick( { action } ) }
                            disabled={ 'cancel' !== action.name ? ! props.canMoveForward : false }
                        />
                    );
                } ) }
            </div>
        </div>
    );
};

// set display name
_epostInsuranceInformation.displayName = 'epostInsuranceInformation';

// set default props
_epostInsuranceInformation.defaultProps = {};

// prop types
_epostInsuranceInformation.propTypes = {};


/***************************************************** */

export const epostInsuranceInformationPreloader = () => {
    return (
        <div className='ui-epost-insurance-information-preloader'>

            <div className='ui-epost-insurance-information-preloader__basic'>
                <InsuranceBasicInformationFormPreloaderPreloader />
                <MemberInfoCommunicationSettingsPreloader />
            </div>

            <div className='ui-epost-insurance-information-preloader__drug'>
                <div className='ui-epost-insurance-information-preloader__drug__title'>
                    <div className='ui-epost-insurance-information-preloader__drug__title__icon'></div>
                    <div className='ui-epost-insurance-information-preloader__drug__title__value'></div>
                </div>
                <div className='ui-epost-insurance-information-preloader__drug__message'></div>
                <div className='ui-epost-insurance-information-preloader__drug__options'>
                    { map( [ ...Array( 2 ).keys() ], item => {
                        return (
                            <div key={ item } className='ui-epost-insurance-information-preloader__drug__options__option'>
                                <div className='ui-epost-insurance-information-preloader__drug__options__option__item'></div>
                                <div className='ui-epost-insurance-information-preloader__drug__options__option__title'></div>
                            </div>
                        );
                    } ) }
                </div>
            </div>

            <div className='ui-epost-insurance-information-preloader__insurance'>
                <div className='ui-epost-insurance-information-preloader__insurance__title'>
                    <div className='ui-epost-insurance-information-preloader__insurance__title__icon'></div>
                    <div className='ui-epost-insurance-information-preloader__insurance__title__value'></div>
                </div>
                <div className='ui-epost-insurance-information-preloader__insurance__cells'>
                    { map( [ ...Array( 5 ).keys() ], item => {
                        return (
                            <div key={ item } className='ui-epost-insurance-information-preloader__insurance__cells__cell'>
                                <div className='ui-epost-insurance-information-preloader__insurance__cells__cell__title'></div>
                                <div className='ui-epost-insurance-information-preloader__insurance__cells__cell__value'></div>
                            </div>
                        );
                    } ) }
                </div>
            </div>

            <MemberInfoCommunicationSettingsPreloader />
            <div className='ui-epost-insurance-information-preloader__actions'>
                { map( [ ...Array( 2 ).keys() ], item => {
                    return (
                        <div key={ item } className='ui-epost-insurance-information-preloader__actions__action'></div>
                    );
                } ) }
           </div>
        </div>
    );
};

// set display name
epostInsuranceInformationPreloader.displayName = 'epostInsuranceInformation';

// set default props
epostInsuranceInformationPreloader.defaultProps = {};

// prop types
epostInsuranceInformationPreloader.propTypes = {};

/***************************************************** */

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { epostInsuranceInformation as EpostInsuranceInformation } from 'ui/views/widgets/epostInsuranceInformation';
 *
 * // render
 * <EpostInsuranceInformation propName='propValue'/>
 */

export const epostInsuranceInformation = withNetworkState( epostInsuranceInformationPreloader, _epostInsuranceInformation );
